__turbopack_context__.v({
  "card": "AcrSecuritySolutions-module__4LwFwW__card",
  "dark": "AcrSecuritySolutions-module__4LwFwW__dark",
  "desc": "AcrSecuritySolutions-module__4LwFwW__desc",
  "heading": "AcrSecuritySolutions-module__4LwFwW__heading",
  "iconBox": "AcrSecuritySolutions-module__4LwFwW__iconBox",
  "light": "AcrSecuritySolutions-module__4LwFwW__light",
  "title": "AcrSecuritySolutions-module__4LwFwW__title",
  "topDesc": "AcrSecuritySolutions-module__4LwFwW__topDesc",
  "wrapper": "AcrSecuritySolutions-module__4LwFwW__wrapper",
});
